/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Loss_MessagesInputs */



/**
* | output |
* | --- |
* | "Unlimited messages" |
*
* @param {Plan_Tab_Downgrade_Loss_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_loss_messages = /** @type {((inputs?: Plan_Tab_Downgrade_Loss_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Loss_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Nachrichten")
	return /** @type {LocalizedString} */ ("Unlimited messages")
});